export const config = {
  testnet: {
    credenza: {
      apiUrl: "https://api.testnets.credenza.online",
      generalWssUrl: "wss://general-staging-staging.up.railway.app",
      evmWssUrl: "wss://evm-staging-staging.up.railway.app",
      gitbookUrl: `https://developer.credenza3.com/credenza-sdk-v3.0/`,
      evmApiUrl: "https://evm.staging.credenza3.com",
      suiApiUrl: "https://sui.staging.credenza3.com",
      generalApiUrl: "https://api.staging.credenza3.com",
      accountsApiUrl: "https://accounts-staging-staging.up.railway.app",
      oauthUiUri: "https://auth.staging.credenza3.com",
    },
    stripe: {
      pk: {
        DEFAULT:
          "pk_test_51LJ0nZHfOaPNdSbZUzB3H4D44JoFD0AIfYv4QLSSSxrBs8ch4A5UlpJOXF4OG0fkgppBD2jOrDTCNaGzevnxdH2200rI1wY1cC",
        OH: "pk_test_51Q88NV09wu09MZ3mFHuhO3j7F0GJqUsFxfOojSXyEmBWyn1XNsSqYpt3qTzlOQCqoWPrZXR4XrQUiS5mnwwkctyT00x50hXVty",
      },
    },
  },
  mainnet: {
    credenza: {
      accountsApiUrl: "https://accounts.credenza3.com",
      apiUrl: "https://api.credenza.online",
      generalApiUrl: "https://api.credenza3.com",
      gitbookUrl: `https://developer.credenza3.com/credenza-sdk-v3.0/`,
      evmApiUrl: "https://evm.credenza3.com",
      suiApiUrl: "https://sui.credenza3.com",
      generalWssUrl: "wss://general-prod-prod.up.railway.app",
      evmWssUrl: "wss://evm-prod-prod.up.railway.app",
      oauthUiUri: "https://auth.credenza3.com",
    },
    stripe: {
      pk: {
        DEFAULT:
          "pk_live_51LJ0nZHfOaPNdSbZpj7gaAUfmbfWylFaORiGxRxyVn8efm1hMTP6Cz2ihL1AhEcUu9AyqTKsUblMQL5m0YU6HTg3001izgq3Fj",
        OH: "pk_live_51Q88NV09wu09MZ3mt4QLre8zWqEcNDrpBEnnoiJaEA1v5MI3XBEX3iIn83OILmbCr7QrQtB9GIcM1hxmkPfBHRmH00azqgbOQj",
      },
    },
  },
};
